/**
 * Copyright (c) 2020-2021 Perficient, Inc.
 * Unauthorized copying or distribution of this file prohibited without the express permission of Perficient.
 */

import React from "react";
import TextField from "@material-ui/core/TextField";
import Autocomplete from "@material-ui/lab/Autocomplete";
import CheckBoxOutlineBlankIcon from "@material-ui/icons/CheckBoxOutlineBlank";
import CheckBoxIcon from "@material-ui/icons/CheckBox";
import { Checkbox, InputAdornment, Tooltip, Typography } from "@material-ui/core";
import { EXTERNAL_CONTACT_TOOLTIPS } from "../../../../../utility/toolTipMessages";

const AzureGroupsDropdown = ({ items, selectedItems, onChange }) => {
	const optionRenderer = (option, { selected }) => (
		<React.Fragment>
			<Checkbox
				icon={<CheckBoxOutlineBlankIcon fontSize="small" />}
				checkedIcon={<CheckBoxIcon fontSize="small" />}
				style={{ marginRight: 8 }}
				checked={selected}
			/>
			{option}
		</React.Fragment>
	);

	const tagsRenderer = (value) => {
		const numTags = value.length;
		return <Typography>{numTags && `${numTags} Group(s) Selected`}</Typography>;
	};
	const getOptionSelected = (option, anotherOption) => {
		return option === anotherOption;
	};

	return (
		<Autocomplete
			multiple
			options={items}
			style={{ minWidth: 270, alignSelf: "center" }}
			value={selectedItems || []}
			disableCloseOnSelect
			getOptionSelected={getOptionSelected}
			renderTags={tagsRenderer}
			noOptionsText={"No Groups to select"}
			onChange={(_event, newValue) => {
				onChange(newValue);
			}}
			renderOption={optionRenderer}
			renderInput={(params) => (
				<TextField
					{...params}
					placeholder={selectedItems?.length ? "" : "Azure AD Groups"}
					style={{ minWidth: "20%" }}
					InputLabelProps={{
						shrink: true,
					}}
					InputProps={{
						...params.InputProps,
						style: {
							minHeight: 32,
						},
						startAdornment: (
							<>
								<InputAdornment position="start">
									<Tooltip
										arrow
										interactive
										placement={"bottom-start"}
										title={EXTERNAL_CONTACT_TOOLTIPS.AZURE_GROUPS_AUTOCOMPLETE}
									>
										<i style={{ height: "15px", color: "gray" }} className="fas fa-info-circle" />
									</Tooltip>
								</InputAdornment>
								{params.InputProps.startAdornment}
							</>
						),
					}}
				/>
			)}
		/>
	);
};

export default AzureGroupsDropdown;
